// import React, { useState, useEffect } from "react";
// import { Tabs, Row, Col, Spin, Table, Card, Collapse, Button, Modal, Input, Divider, message } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { fetchEnrollmentDetails, fetchDependentDetails, fetchEnrollmentDetailsData } from "../../Action/Actions";
// import { useSelectedYear } from "../../Context/SelectYearContext";
// import { getUserData } from "../login/LoginSlice";
// import { UserOutlined, ExportOutlined, TeamOutlined, SearchOutlined, FileAddOutlined, FireOutlined, FilePdfOutlined } from "@ant-design/icons";
// import DataTable from "../DataTable/DataTable";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const EnrollmentDetails = () => {
//   const user = useSelector(getUserData);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchQuery, setSearchQuery] = useState('');
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const AuthData = useSelector(getUserData);
//   const [activeTab, setActiveTab] = useState("GMC");
//   const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
//   const { selectedYear } = useSelectedYear();
//   const [enrollmentData, setEnrollmentData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const policyTypes = Object.keys(enrollmentData || {});
//   const { Panel } = Collapse;
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [dependentData, setDependentData] = useState([]);
//   const [isCardModalVisible, setIsCardModalVisible] = useState(false);

//   const hasIntimateClaimAccess = AuthData?.module_data?.some(
//     (module) => module.module_option_ids?.includes(5)
//   );
//    const [selectedPolicyid, setSelectedPolicyid] = useState(null);
//     const [claimDatatable, setClaimDatatable] = useState([]);

//     const fetchEnrollmentTable = async (policyid, page = 1) => {
//       try {
//         if (policyid) {
//           setLoading(true);
//           const data = await dispatch(fetchEnrollmentDetailsData(policyid, page));
//           if (!data || !data.enrollment) {
//             console.warn("No enrollment data returned from API.");
//             setClaimDatatable([]);
//             setPagination({
//               ...pagination,
//               current: 1,
//               total: 0,
//             });
//             return;
//           }

//           const { enrollment } = data;
//           setClaimDatatable(enrollment?.data || []);
//           setPagination({
//             ...pagination,
//             current: enrollment?.current_page,
//             total: enrollment?.total,
//           });
//         } else {
//           console.warn("No valid policyid provided for fetchEnrollmentTable.");
//         }
//       } catch (err) {
//         console.error("Error fetching enrollment details data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     useEffect(() => {
//       if (selectedPolicyid) {
//         fetchEnrollmentTable(selectedPolicyid, pagination.current);
//       } else {
//         console.warn("No valid policyid available for fetchEnrollmentTable.");
//       }
//     }, [selectedPolicyid, pagination.current, dispatch]);

//     useEffect(() => {
//       const fetchEnrollmentData = async () => {
//         try {
//           if (AuthData?.corporate_id) {
//             setLoading(true);
//             const data = await dispatch(fetchEnrollmentDetails(AuthData?.corporate_id));
//             const { policy_enrollment_details } = data;

            // NEW: Filter out restricted policy types
//             const filteredDetails = {};
//             for (const type in policy_enrollment_details) {
//               const policies = policy_enrollment_details[type] || [];
//               const validPolicies = policies.filter(p => !RESTRICTED_POLICY_TYPE_IDS.includes(Number(p.policy_details?.policy_type_id)));
//               if (validPolicies.length > 0) {
//                 filteredDetails[type] = validPolicies;
//               }
//             }
// 
//             console.log("filtered_policy_enrollment_details:", filteredDetails);
//             console.log("activeTab:", activeTab);
// 
//             if (filteredDetails && filteredDetails[activeTab] && filteredDetails[activeTab].length > 0) {
//               const firstPolicyNumber = filteredDetails[activeTab][0]?.policy_details?.policy_number;
//               setSelectedPolicyNumber(firstPolicyNumber || null);
// 
//               const policyid = filteredDetails[activeTab][0]?.policy_details?.policy_id;
//               console.log("policyid:", policyid); // Debugging log
//               setSelectedPolicyid(policyid);
//             } else {
//               console.warn("No data found for activeTab:", activeTab);
//               setSelectedPolicyid(null); // Reset policyid if no data is found
//             }
// 
//             setEnrollmentData(filteredDetails || {});
//           }
//         } catch (err) {
//           console.error("Error fetching enrollment details data:", err);
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchEnrollmentData();
//     }, [dispatch, AuthData, activeTab]);



//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     const PolicyNumber = enrollmentData[key]?.[0]?.policy_details?.policy_number;
//     setSelectedPolicyNumber(PolicyNumber || null);
//   };

//   const handlePolicyNumberClick = (policyNumber) => {
//     setSelectedPolicyNumber(policyNumber);
//   };

//   const handleTableChange = (pagination) => {
//     fetchEnrollmentTable(selectedPolicyid,pagination.current);
//    };
//   const handleViewDependent = async (employeeCode) => {
//     try {
//       const data = await dispatch(fetchDependentDetails(employeeCode));
//       setDependentData(data.Dependant_Details || []);
//       setIsModalVisible(true);
//     } catch (error) {
//       message.error("Failed to fetch dependent data");
//     }
//   };

//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleCardModalCancel = () => {
//     setIsCardModalVisible(false);
//   };

//   const handleViewCard = () => {
//     setIsCardModalVisible(true);
//   };

//   const filteredDependentData = Array.isArray(dependentData)
//     ? dependentData.filter(item => item.employee_name.toLowerCase().includes(searchQuery.toLowerCase()))
//     : [];

//   const filteredData = enrollmentData[activeTab] || [];
//   const paginatedData = filteredData.slice(
//     (pagination.current - 1) * pagination.pageSize,
//     pagination.current * pagination.pageSize
//   );

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setPagination({
//       ...pagination,
//       current: 1,
//     });
//   };

//   const handlePaginationChange = (page, pageSize) => {
//     setPagination({
//       current: page,
//       pageSize,
//       total: filteredDependentData.length,
//     });
//   };

//   const getTabIcon = (type) => {
//     switch (type) {
//       case "GMC":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "GTL":
//         return <UserOutlined style={{ marginRight: 8 }} />;
//       case "GPA":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "Parent policy":
//         return <TeamOutlined style={{ marginRight: 8 }} />;
//       case "Topup":
//         return <FileAddOutlined style={{ marginRight: 8 }} />;
//       case "Fire":
//         return <FireOutlined style={{ marginRight: 8 }} />;
//       default:
//         return null;
//     }
//   };

//   const handleExport = () => {
//     const dataToExport = filteredData.map((data, index) => ({
//       SINO: index + 1,
//       EmployeeName: data?.employee_name || "N/A",
//       EmployeeID: data?.employee_code || "N/A",
//       MemberID: data?.member_id || "N/A",
//       SumInsured: data?.sum_insured || "N/A",
//       MobileNumber: data?.mobile_number || "N/A",
//       Email: data?.email || "N/A",
//       Gender: data?.gender || "N/A",
//       PolicyNumber: data?.policy_details?.policy_number || "N/A",
//     }));
//      const csvContent = [
//           ["No", "EmployeeName", "EmployeeID","MemberID", "SumInsured", "MobileNumber","Email","Gender","PolicyNumber"],
//           ...dataToExport.map((item) =>
//             Object.values(item).map((value) => `"${value}"`)
//           ),
//         ]
//           .map((row) => row.join(","))
//           .join("\n");

//         const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//         saveAs(blob, `Enrollment_details_${selectedYear}.csv`);
//   };

//   const PolicyDetailsTable = ({ policy }) => {
//     const columns = [
//       {
//         title: "SI NO",
//         dataIndex: "si_no",
//         key: "si_no",
//         render: (_, __, index) => {
//           const pageIndex = pagination.current || 1;
//           const pageSize = pagination.pageSize || 10;
//           return (pageIndex - 1) * pageSize + index + 1;
//         },
//       },
//       {
//         title: "EMPLOYEE NAME",
//         dataIndex: "employee_name",
//         key: "employee_name",
//       },
//       {
//         title: "EMPLOYEE CODE",
//         dataIndex: "employee_code",
//         key: "employee_code",
//       },
//       {
//         title: "MEMBER ID",
//         dataIndex: "member_id",
//         key: "member_id",
//       },
//       {
//         title: "SUM INSURED",
//         dataIndex: "sum_insured",
//         key: "sum_insured",
//       },
//       {
//         title: "DEPENDENT",
//         dataIndex: "dependent",
//         key: "dependent",
//         render: (_, record) => (
//           <Button
//             className="d-flex-table"
//             icon={<TeamOutlined />}
//             onClick={() => handleViewDependent(record.employee_code)}
//             type="button"
//             style={{ background: "#1890ff" }}
//           >
//             View Dependent
//           </Button>
//         ),
//       },
//       {
//         title: "CARDS",
//         dataIndex: "cards",
//         key: "cards",
//         render: (_, record) => (
//           <Button
//             className="d-flex-table"
//             onClick={handleViewCard}
//             type="button"
//             style={{ background: "#1890ff" }}
//           >
//             View Card
//           </Button>
//         ),
//       },
//       {
//       title: "INTIMATE",
//         dataIndex: "intimate",
//         key: "intimate",
//         render: (_, record) => (
//           <Button
//             type="Button"
//             onClick={() => navigate(`/corporate/Claims`)}
//             style={{ background: "#1890ff", color: "white" }}
//             disabled={!hasIntimateClaimAccess}
//           >
//             Intimate Claim
//           </Button>
//         ),
//       },
//       {
//         title: "EMPLOYEE MOBILE NUMBER",
//         dataIndex: "mobile_number",
//         key: "mobile_number",
//       },
//       {
//         title: "EMPLOYEE EMAIL",
//         dataIndex: "email",
//         key: "email",
//       },
//       {
//         title: "EMPLOYEE GENDER",
//         dataIndex: "gender",
//         key: "gender",
//       },
//     ];
//     const StaticData = [
//       {
//         si_no: 1,
//         employee_name: "John Doe",
//         employee_code: "EMP123",
//         member_id: "MEM001",
//         sum_insured: "₹1,00,000",
//         dependent: "Jane Doe",
//         mobile_number: "1234567890",
//         email: "john.doe@example.com",
//         gender: "Male",
//       },

//     ];

//     return (
//       <Card style={{ width: "100%" }}>
//         <Card>
//           <Collapse defaultActiveKey={["1"]} className="custom-collapse">
//             <Panel header="Policy Details" key="1">
//               <Row gutter={[16, 16]}>
//                 <Col className="col-lg-4 col-md-4  collapse-content">
//                   <strong>Policy Number:</strong> {policy.policy_number || "N/A"}
//                 </Col>
//                 <Col className="col-lg-4 col-md-4 collapse-content">
//                   <strong>Policy Start Date:</strong>{" "}
//                   {policy.policy_startdate || "N/A"}
//                 </Col>
//                 <Col className="col-lg-4 col-md-4 collapse-content">
//                   <strong>Policy End Date:</strong>{" "}
//                   {policy.policy_end_date || "N/A"}
//                 </Col>
//                 <Col className="col-lg-4 col-md-4 collapse-content">
//                   <strong>Insurer:</strong> 
//                   {policy.policy_select_insurer || "N/A"}
//                 </Col>
//                 <Col className="col-lg-4 col-md-4 collapse-content">
//                   <strong>TPA:</strong> 
//                   {policy.policy_select_tpa || "N/A"}
//                 </Col>
//               </Row>
//             </Panel>
//           </Collapse>
//           <div className="row justify-content-center px-3 py-3 bg-label">
//             <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
//               <Card className="label-card">
//                 <div className="d-flex gap-2">
//                   <div className="my-auto label-icon-bg">
//                     <UserOutlined className="label-icon" />
//                   </div>

//                   <div className="label-sec">
//                     <h6>Employees</h6>
//                     <ul style={{ paddingLeft: "0px" }}>
//                       <li
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <span>Total </span>
//                         {"  "}-{" "}
//                         <span>{policy.enrollment_count?.employee_count || "0"}</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </Card>
//             </div>
//             <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
//               <Card className="label-card">
//                 <div className="d-flex gap-2">
//                   <div className="my-auto label-icon-bg">
//                     <UserOutlined className="label-icon" />
//                   </div>

//                   <div className="label-sec">
//                     <h6>Dependents</h6>
//                     <ul style={{ paddingLeft: "0px" }}>
//                       <li
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <span>Total </span>
//                         {"  "}-{" "}
//                         <span>{policy.enrollment_count?.dependent_count || "0"}</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </Card>
//             </div>
//             <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
//               <Card className="label-card">
//                 <div className="d-flex gap-2">
//                   <div className="my-auto label-icon-bg">
//                     <UserOutlined className="label-icon" />
//                   </div>

//                   <div className="label-sec">
//                     <h6>Lives</h6>
//                     <ul style={{ paddingLeft: "0px" }}>
//                       <li
//                         style={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <span>Total</span>
//                         {"  "}-{""}
//                         <span>{policy.enrollment_count?.total_count || "0"}</span>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </Card>
//             </div>
//           </div>
//           <Row
//             gutter={16}
//             className="mb-3 justify-content-between align-items-center px-3"
//             style={{ display: "flex", justifySelf: "flex-end" }}
//           >
//             <Col xs={24} sm={2} md={2} lg={2} xl={2}>
//               <Button
//                 type="primary"
//                  onClick={handleExport}
//                 icon={<ExportOutlined />}
//                 className="d-flex"
//               >
//                 Export
//               </Button>
//             </Col>
//           </Row>

//           <DataTable
//             columns={columns}
//             //  dataSource={policy.policy_details?.enrollment_list || []}
//           dataSource={claimDatatable || []} 
//             loading={loading}
//             rowKey="id"
//             pagination={pagination}
//            onChange={handleTableChange}
//           />
//         </Card>
//       </Card>
//     );
//   };

//   const handlePolicyNumberClick = (key) => {
//     const selectedPolicy = enrollmentData[activeTab].find(
//       (policy) => (policy.policy_details.policy_number?.trim() || policy.policy_details.policy_id) === key
//     );

//     if (selectedPolicy) {
//       const policyNum = selectedPolicy.policy_details.policy_number?.trim() || selectedPolicy.policy_details.policy_id;
//       const policyId = selectedPolicy.policy_details.policy_id;

//       setSelectedPolicyNumber(policyNum);
//       setSelectedPolicyid(policyId);
//       fetchEnrollmentTable(policyId);
//     }
//   };

//   const tabItems = policyTypes?.map((type) => ({
//     key: type,
//     label: (
//       <>
//         <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//           {type}
//           {getTabIcon(type)}
//         </span>
//       </>
//     ),
//     children: (
//       <>
//         <Tabs
//           activeKey={selectedPolicyNumber}
//           onChange={handlePolicyNumberClick}
//           items={enrollmentData[type]?.map((policy) => ({
//             key: policy.policy_details?.policy_number || "Policy not yet issued",
//             label: (
//               <span style={{ backgroundColor: policy.policy_details?.policy_number ? "transparent" : "yellow" }}>
//                 {policy.policy_details?.policy_number || "Policy not yet issued"}
//               </span>
//                ),
//               })) || []}
//         />
//         {selectedPolicyNumber &&
//         enrollmentData[type]?.some(
//           (policy) => policy.policy_details.policy_number === selectedPolicyNumber
//         ) ? (
//           <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
//             {enrollmentData[type]
//               .filter((policy) => policy.policy_details.policy_number === selectedPolicyNumber)
//               .map((policy) => (
//                 <Col key={policy.policy_details.policy_number} span={24}>
//                   <PolicyDetailsTable policy={policy.policy_details} />
//                 </Col>
//               ))}
//           </Row>
//         ) : (
//           <div className="escalation-message">No Enrollment Details Found.</div>
//         )}
//       </>
//     ),
//   }));
import React, { useState, useEffect, useCallback } from "react";
import {
  Tabs,
  Row,
  Col,
  Spin,
  Table,
  Card,
  Collapse,
  Button,
  Modal,
  Input,
  Divider,
  message,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchEnrollmentDetails,
  fetchDependentDetails,
  fetchEnrollmentDetailsData,
  getEcardDocument,
  corporateEnrollmentDetailsExport,
} from "../../Action/Actions";
// UPDATED: Removed context import
// import { useSelectedYear } from "../../Context/SelectYearContext";
import { getUserData } from "../login/LoginSlice";
// UPDATED: Added imports for Redux financial year state
import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice";
import {
  UserOutlined,
  ExportOutlined,
  TeamOutlined,
  SearchOutlined,
  FileAddOutlined,
  FireOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import DataTable from "../DataTable/DataTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const { Panel } = Collapse;
const RESTRICTED_POLICY_TYPE_IDS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

const PolicyDetailsTable = ({
  policy,
  claimDatatable,
  loading,
  pagination,
  handleTableChange,
  handleViewDependent,
  handleViewCard,
  handleExport,
  activeTab,
  hasIntimateClaimAccess,
  navigate
}) => {
  const columns = [
    {
      title: "SI NO",
      dataIndex: "si_no",
      key: "si_no",
      render: (_, __, index) => {
        const pageIndex = pagination.current || 1;
        const pageSize = pagination.pageSize || 10;
        return (pageIndex - 1) * pageSize + index + 1;
      },
    },
    { title: "EMPLOYEE NAME", dataIndex: "employee_name", key: "employee_name", searchable: true },
    { title: "EMPLOYEE CODE", dataIndex: "employee_code", key: "employee_code", searchable: true },
    { title: "MEMBER ID", dataIndex: "member_id", key: "member_id" },
    { title: "SUM INSURED", dataIndex: "sum_insured", key: "sum_insured", searchable: true },
    {
      title: "DEPENDENT",
      dataIndex: "dependent",
      key: "dependent",
      render: (_, record) => (
        <Button
          className="d-flex-table"
          icon={<TeamOutlined />}
          onClick={() => {
            const policyId = policy?.policy_details?.policy_id;
            handleViewDependent(record.employee_code, policyId);
          }}
          type="button"
          style={{ background: "#1890ff" }}
        // disabled={["GPA", "GTL", "Parent policy"].includes(activeTab)}
        >
          View Dependent
        </Button>
      ),
    },
    (["GMC", "Parent policy", "Parent Policy", "Topup", "Top up policy", "Top Up Policy", "Topup Policy"].includes(activeTab)) && {
      title: "CARDS",
      dataIndex: "cards",
      key: "cards",
      render: (_, record) => (
        <Button
          className="d-flex-table"
          onClick={() => handleViewCard(record.employee_code, policy?.policy_details?.policy_id)}
          type="button"
          style={{ background: "#1890ff" }}
        >
          View Card
        </Button>
      ),
    },
    {
      title: "INTIMATE",
      dataIndex: "intimate",
      key: "intimate",
      render: (_, record) => (
        <Button
          type="Button"
          onClick={() =>
            navigate("/corporate/Claims", {
              state: {
                activeTab: 1,
                employeeCode: record.employee_code,
                employeeName: record.employee_name,
              },
            })
          }
          style={{ background: "#1890ff", color: "white" }}
          disabled={!hasIntimateClaimAccess}
        >
          Intimate Claim
        </Button>
      ),
    },
    { title: "EMPLOYEE MOBILE NUMBER", dataIndex: "mobile_number", key: "mobile_number", searchable: true },
    { title: "EMPLOYEE EMAIL", dataIndex: "email", key: "email", searchable: true },
    { title: "EMPLOYEE GENDER", dataIndex: "gender", key: "gender", searchable: true },
  ].filter(Boolean);

  return (
    <Card style={{ width: "100%" }}>
      <Card>
        <Collapse activeKey={["1"]} className="custom-collapse">
          <Panel header="Policy Details" key="1">
            <Row gutter={[16, 16]}>
              <Col className="col-lg-4 col-md-4  collapse-content"><strong>Policy Number:</strong> {policy.policy_details.policy_number || "N/A"}</Col>
              <Col className="col-lg-4 col-md-4 collapse-content"><strong>Policy Start Date:</strong> {policy.policy_details.policy_startdate || "N/A"}</Col>
              <Col className="col-lg-4 col-md-4 collapse-content"><strong>Policy End Date:</strong> {policy.policy_details.policy_end_date || "N/A"}</Col>
              <Col className="col-lg-4 col-md-4 collapse-content"><strong>Insurer:</strong> {policy.policy_details.policy_select_insurer || "N/A"}</Col>
              <Col className="col-lg-4 col-md-4 collapse-content"><strong>TPA:</strong> {policy.policy_details.policy_select_tpa || "N/A"}</Col>
            </Row>
          </Panel>
        </Collapse>
        <div className="row justify-content-center px-3 py-3 bg-label">
          <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
            <Card className="label-card">
              <div className="d-flex gap-2">
                <div className="my-auto label-icon-bg"><UserOutlined className="label-icon" /></div>
                <div className="label-sec">
                  <h6>Employees</h6>
                  <ul style={{ paddingLeft: "0px" }}>
                    <li style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Total </span><span style={{ marginLeft: "8px", marginRight: "8px" }}>-</span>
                      <span>{policy.enrollment_count?.employee_count || "0"}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
            <Card className="label-card">
              <div className="d-flex gap-2">
                <div className="my-auto label-icon-bg"><UserOutlined className="label-icon" /></div>
                <div className="label-sec">
                  <h6>Dependents</h6>
                  <ul style={{ paddingLeft: "0px" }}>
                    <li style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Total </span><span style={{ marginLeft: "8px", marginRight: "8px" }}>-</span>
                      <span>{policy.enrollment_count?.dependent_count || "0"}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>
          </div>
          <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12">
            <Card className="label-card">
              <div className="d-flex gap-2">
                <div className="my-auto label-icon-bg"><UserOutlined className="label-icon" /></div>
                <div className="label-sec">
                  <h6>Lives</h6>
                  <ul style={{ paddingLeft: "0px" }}>
                    <li style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Total</span><span style={{ marginLeft: "8px", marginRight: "8px" }}>-</span>
                      <span>{policy.enrollment_count?.total_count || "0"}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <Row gutter={16} className="mb-3 justify-content-end align-items-center px-3">
          <Col>
            <Button type="primary" onClick={handleExport} icon={<ExportOutlined />} className="d-flex" loading={loading}>
              Export
            </Button>
          </Col>
        </Row>
        <DataTable columns={columns} dataSource={claimDatatable || []} loading={loading} rowKey="id" pagination={pagination} onChange={handleTableChange} />
      </Card>
    </Card>
  );
};

const EnrollmentDetails = () => {
  const user = useSelector(getUserData);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const AuthData = useSelector(getUserData);
  const [activeTab, setActiveTab] = useState("");
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);

  // UPDATED: Get financial year details from Redux instead of Context
  const selectedYearId = useSelector(selectSelectedYearId);
  const yearList = useSelector(selectFinancialYears);
  const selectedYear = yearList.find(year => year.id === selectedYearId)?.financial_year || "";

  const [enrollmentData, setEnrollmentData] = useState({});
  const [loading, setLoading] = useState(false);
  const policyTypes = Object.keys(enrollmentData || {});
  const [errorMessage, setErrorMessage] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dependentData, setDependentData] = useState([]);
  const [isCardModalVisible, setIsCardModalVisible] = useState(false);
  const [eCardUrl, setECardUrl] = useState(null);
  const hasIntimateClaimAccess = AuthData?.module_data?.some((module) =>
    module.module_option_ids?.includes(5)
  );
  const [selectedPolicyid, setSelectedPolicyid] = useState(null);
  const [claimDatatable, setClaimDatatable] = useState([]);
  const [filters, setFilters] = useState({});

  const fetchEnrollmentTable = async (policyid, page = 1, pageSize = pagination.pageSize, searchParams = filters) => {
    try {
      if (policyid) {
        setLoading(true);
        const data = await dispatch(fetchEnrollmentDetailsData(policyid, page, pageSize, searchParams));
        if (!data || !data.enrollment) {
          console.warn("No enrollment data returned from API.");
          setClaimDatatable([]);
          setPagination({
            current: 1,
            pageSize: pageSize,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          });
          return;
        }

        const { enrollment } = data;
        setClaimDatatable(enrollment?.data || []);
        setPagination({
          current: enrollment?.current_page || 1,
          pageSize: pageSize,
          total: Number(enrollment?.total || 0),
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        });
      } else {
        console.warn("No valid policyid provided for fetchEnrollmentTable.");
      }
    } catch (err) {
      console.error("Error fetching enrollment details data:", err);
    } finally {
      setLoading(false);
    }
  };

  // UPDATED: Fetch policies when year changes
  useEffect(() => {
    const fetchPolicies = async () => {
      if (!AuthData?.corporate_id || !selectedYearId) {
        setLoading(false);
        setEnrollmentData({});
        setSelectedPolicyid(null);
        setSelectedPolicyNumber(null);
        setClaimDatatable([]);
        return;
      }
      try {
        setLoading(true);

        // Fetch enrollment details (policies list)
        const enrollmentDataResponse = await dispatch(fetchEnrollmentDetails(AuthData.corporate_id));
        const { policy_enrollment_details } = enrollmentDataResponse;

        // NEW: Filter out restricted policy types
        const filteredDetails = {};
        for (const type in policy_enrollment_details) {
          // Robust Name-based check to skip "Marine" and "Fire" and others in IDs 6-16
          const typeName = String(type).toLowerCase();
          if (typeName.includes('marine') || typeName.includes('fire')) {
            continue;
          }

          const policies = policy_enrollment_details[type] || [];
          const validPolicies = policies.filter(p => {
            const details = Array.isArray(p.policy_details) ? p.policy_details[0] : p.policy_details;
            const typeId = details?.policy_type_id || p.policy_type_id || p.policy_details?.policy_type_id;
            const isRestrictedId = RESTRICTED_POLICY_TYPE_IDS.includes(Number(typeId));
            return !isRestrictedId;
          });
          if (validPolicies.length > 0) {
            filteredDetails[type] = validPolicies;
          }
        }

        // Set enrollment data
        setEnrollmentData(filteredDetails || {});

        // Get policy types that actually have data (not empty arrays)
        const availableTabs = Object.keys(filteredDetails || {}).filter(
          (tab) => filteredDetails[tab] && filteredDetails[tab].length > 0
        );

        // Use the first available type that has data
        const tabToUse = availableTabs.length > 0 ? availableTabs[0] : "";

        // Update activeTab to the first available type with data
        if (tabToUse && tabToUse !== activeTab) {
          setActiveTab(tabToUse);
        }
      } catch (err) {
        console.error("Error fetching enrollment policies:", err);
        setEnrollmentData({});
        setClaimDatatable([]);
        setSelectedPolicyid(null);
        setSelectedPolicyNumber(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, [dispatch, AuthData?.corporate_id, selectedYearId]);

  // UPDATED: Fetch table data when activeTab or enrollmentData changes
  useEffect(() => {
    const fetchTableData = async () => {
      if (!enrollmentData || Object.keys(enrollmentData).length === 0) {
        return;
      }

      const tabToUse = activeTab;

      if (
        enrollmentData[tabToUse] &&
        enrollmentData[tabToUse].length > 0
      ) {
        const firstPolicy = enrollmentData[tabToUse][0];
        // Use the same logic as the filter: policy_number if available, otherwise policy_id
        const policyNumber = firstPolicy.policy_details?.policy_number?.trim() || firstPolicy.policy_details?.policy_id;
        const policyId = firstPolicy.policy_details?.policy_id;

        setSelectedPolicyNumber(policyNumber);
        setSelectedPolicyid(policyId);

        // Fetch table data for this policy
        if (policyId) {
          try {
            setLoading(true);
            const tableDataResponse = await dispatch(fetchEnrollmentDetailsData(policyId, 1, pagination.pageSize, filters));

            if (tableDataResponse && tableDataResponse.enrollment) {
              const { enrollment } = tableDataResponse;
              setClaimDatatable(enrollment?.data || []);
              setPagination({
                current: enrollment?.current_page || 1,
                pageSize: pagination.pageSize,
                total: Number(enrollment?.total || 0),
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
              });
            } else {
              setClaimDatatable([]);
            }
          } catch (err) {
            console.error("Error fetching table data:", err);
            setClaimDatatable([]);
          } finally {
            setLoading(false);
          }
        }
      } else {
        setSelectedPolicyid(null);
        setSelectedPolicyNumber(null);
        setClaimDatatable([]);
        setPagination({
          current: 1,
          pageSize: pagination.pageSize,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        });
      }
    };

    fetchTableData();
  }, [dispatch, enrollmentData, activeTab]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    const firstPolicy = enrollmentData[key]?.[0]?.policy_details;
    if (firstPolicy) {
      // Use policy_number if available, fallback to policy_id as key for "Policy not yet issued"
      const displayValue = firstPolicy.policy_number?.trim() || firstPolicy.policy_id;
      setSelectedPolicyNumber(displayValue);
      setSelectedPolicyid(firstPolicy.policy_id);
      setFilters({}); // Reset filters on tab change
      // Fetch table data for the first policy in this tab
      if (firstPolicy.policy_id) {
        fetchEnrollmentTable(firstPolicy.policy_id, 1, pagination.pageSize, {});
      }
    } else {
      setSelectedPolicyNumber(null);
      setSelectedPolicyid(null);
    }
  };

  const handlePolicyNumberClick = (policyNumber) => {
    setSelectedPolicyNumber(policyNumber);
    const selectedPolicy = enrollmentData[activeTab]?.find((p) => {
      const key = p.policy_details?.policy_number?.trim() || p.policy_details?.policy_id;
      return key === policyNumber;
    });
    if (selectedPolicy?.policy_details) {
      const policyId = selectedPolicy.policy_details.policy_id;
      setSelectedPolicyid(policyId);
      setFilters({}); // Reset filters on policy change
      // Fetch table data for this policy
      if (policyId) {
        fetchEnrollmentTable(policyId, 1, pagination.pageSize, {});
      }
    }
  };

  const handleTableChange = (newPagination, tableFilters) => {
    const { current, pageSize } = newPagination;

    // Extract search parameters from Ant Design filters
    const searchParams = Object.keys(tableFilters || {}).reduce((acc, key) => {
      if (tableFilters[key] && tableFilters[key].length > 0) {
        acc[key] = tableFilters[key][0];
      }
      return acc;
    }, {});

    setFilters(searchParams);
    fetchEnrollmentTable(selectedPolicyid, current, pageSize, searchParams);
  };

  const handleViewDependent = async (employeeCode, policy_id) => {
    try {
      if (!policy_id) {
        message.error("Policy id not available for this policy.");
        return;
      }
      const data = await dispatch(fetchDependentDetails(employeeCode, policy_id));
      // API may return Dependant_Details (misspelled) or Dependent_Details — normalize both
      const dependents = data?.Dependent_Details || data?.Dependant_Details || [];
      // Ensure array and sanitize entries
      const normalized = Array.isArray(dependents)
        ? dependents.map((d) => ({
          relationship: d?.relationship || "",
          employee_name: d?.employee_name || "",
          gender: d?.gender || "",
          dob: d?.dob || "",
          age: d?.age || "",
          mobile_number: d?.mobile_number || "",
          email: d?.email || "",
        }))
        : [];
      setDependentData(normalized);
      setIsModalVisible(true);
    } catch (error) {
      message.error(error.message || "Failed to fetch dependent data");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCardModalCancel = () => {
    setIsCardModalVisible(false);
  };

  const handleViewCard = async (employeeCode, policyId) => {
    try {
      setLoading(true);
      const data = await dispatch(getEcardDocument(employeeCode, policyId));
      const url = data?.employee_ecard?.file_url;

      if (url) {
        setECardUrl(url);
        setErrorMessage(null);
        setIsCardModalVisible(true);
      } else {
        setECardUrl(null);
        setErrorMessage("E-Card URL not found.");
        setIsCardModalVisible(true);
      }
    } catch (error) {
      console.error("Error fetching E-Card:", error);
      setECardUrl(null);
      setErrorMessage("No E-Cards found.");
      setIsCardModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  const filteredDependentData = Array.isArray(dependentData)
    ? dependentData.filter((item) =>
      item.employee_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handlePaginationChange = (page, pageSize) => {
    setPagination((prev) => ({ ...prev, current: page, pageSize }));
  };

  const getTabIcon = (type) => {
    switch (type) {
      case "GMC": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL": return <UserOutlined style={{ marginRight: 8 }} />;
      case "GPA": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Parent policy": return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Topup": return <FileAddOutlined style={{ marginRight: 8 }} />;
      case "Fire": return <FireOutlined style={{ marginRight: 8 }} />;
      default: return null;
    }
  };

  const handleExport = async () => {
    if (!selectedPolicyid) {
      message.error("Please select a policy to export.", 3);
      return;
    }

    message.loading({ content: 'Preparing enrollment details for download...', key: 'exporting' });
    setLoading(true);

    try {
      const downloadLink = await dispatch(corporateEnrollmentDetailsExport(selectedPolicyid));

      if (downloadLink && typeof downloadLink === 'string') {
        const fileName = `Enrollment_details_${selectedPolicyNumber || selectedPolicyid}_${selectedYear}.xlsx`;

        const link = document.createElement('a');
        link.href = downloadLink;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();

        message.success({ content: 'Your download has started!', key: 'exporting', duration: 3 });
      } else {
        throw new Error("A valid download link was not received from the server.");
      }
    } catch (error) {
      console.error("Failed to export enrollment details:", error);
      const errorMessage = typeof error === 'string' ? error : (error.message || "The export could not be completed.");
      message.error({ content: `Export failed: ${errorMessage}`, key: 'exporting', duration: 4 });
    } finally {
      setLoading(false);
    }
  };

  const tabItems = policyTypes?.map((type) => ({
    key: type,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {type}
        {getTabIcon(type)}
      </span>
    ),
    children: (
      <>
        <Tabs
          activeKey={selectedPolicyNumber}
          onChange={handlePolicyNumberClick}
          items={
            enrollmentData[type]?.map((policy) => {
              const policyNum = policy.policy_details?.policy_number?.trim();
              const policyId = policy.policy_details?.policy_id;
              const key = policyNum || policyId;

              // Display policy number or "Policy No. not yet issued" with yellow tag
              const label = policyNum ? (
                policyNum
              ) : (
                <Tag
                  style={{
                    backgroundColor: "#FFFF00",
                    color: "#000000E0",
                    fontSize: "12px",
                    padding: "2px 8px",
                    margin: 0,
                    fontFamily: '"Plus Jakarta Sans", sans-serif',
                    borderRadius: "4px",
                  }}
                >
                  Policy Number not issued
                </Tag>
              );

              return {
                key: key,
                label: label,
              };
            }) || []
          }
        />
        {selectedPolicyNumber && enrollmentData[type]?.some((p) => {
          const key = p.policy_details?.policy_number?.trim() || p.policy_details?.policy_id;
          return key === selectedPolicyNumber;
        }) ? (
          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            {enrollmentData[type]
              .filter((policy) => {
                const key = policy.policy_details?.policy_number?.trim() || policy.policy_details?.policy_id;
                return key === selectedPolicyNumber;
              })
              .map((policy) => {
                const key = policy.policy_details?.policy_number?.trim() || policy.policy_details?.policy_id;
                return (
                  <Col key={key} span={24}>
                    <PolicyDetailsTable
                      policy={policy}
                      claimDatatable={claimDatatable}
                      loading={loading}
                      pagination={pagination}
                      handleTableChange={handleTableChange}
                      handleViewDependent={handleViewDependent}
                      handleViewCard={handleViewCard}
                      handleExport={handleExport}
                      activeTab={activeTab}
                      hasIntimateClaimAccess={hasIntimateClaimAccess}
                      navigate={navigate}
                    />
                  </Col>
                );
              })}
          </Row>
        ) : (
          !loading && <div className="escalation-message">No Enrollment Details Found.</div>
        )}
      </>
    ),
  }));

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-content">
          <Row className="escalation-row-header">
            <span style={{ fontWeight: "700", fontSize: "20px" }}>
              {user?.corporate_name || "Guest"}
            </span>
            {/* UPDATED: This now correctly displays the financial year from Redux */}{" "}
            <span style={{ marginLeft: "8px" }}>
              (Financial Year: {selectedYear})
            </span>
          </Row>
        </div>
        {policyTypes.length > 0 ? (
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            className="esc-tab"
            items={tabItems}
          />
        ) : (
          <Card style={{ marginTop: "20px" }}>
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
              <p style={{ fontSize: "16px", fontWeight: "500" }}>No enrollment details data available for {selectedYear}</p>
            </div>
          </Card>
        )}
      </div>
      <Modal title="Family Dependent" open={isModalVisible} onCancel={handleCancel} footer={null} width={800}>
        <Divider />
        <Row>
          <Col span={18} />
          <Col span={6} style={{ paddingBottom: "20px" }}>
            <Input placeholder="Search Dependents" prefix={<SearchOutlined />} value={searchQuery} onChange={handleSearch} />
          </Col>
        </Row>
        <Table
          columns={[
            { title: 'Relation', dataIndex: 'relationship', key: 'relationship' },
            { title: 'Name', dataIndex: 'employee_name', key: 'employee_name' },
            { title: 'Gender', dataIndex: 'gender', key: 'gender' },
            { title: 'DOB', dataIndex: 'dob', key: 'dob' },
            { title: 'Age', dataIndex: 'age', key: 'age' },
            { title: 'Mobile Number', dataIndex: 'mobile_number', key: 'mobile_number' },
            { title: 'Email', dataIndex: 'email', key: 'email' },
          ]}
          dataSource={filteredDependentData}
          pagination={{ ...pagination, total: filteredDependentData.length, onChange: handlePaginationChange }}
        />
      </Modal>
      <Modal
        title="E-Card"
        open={isCardModalVisible}
        onCancel={() => {
          setIsCardModalVisible(false);
          setECardUrl(null);
          setErrorMessage(null);
        }}
        footer={null}
        width={800}
      >
        <Divider />
        <div style={{ textAlign: "center" }}>
          {eCardUrl ? (
            <>
              <FilePdfOutlined
                style={{ fontSize: "100px", color: "#1890ff", cursor: "pointer" }}
                onClick={() => window.open(eCardUrl, "_blank")}
              />
              <p>View your E-Card</p>
            </>
          ) : (
            <p style={{ fontSize: "16px" }}>
              {errorMessage}
            </p>
          )}
        </div>
      </Modal>
    </Spin>
  );
};

export default EnrollmentDetails;
